/**
 * StarlitTunes — Mobile Enhancements for PbtS Product Page
 * 1. Smaller tracker text on mobile (WCAG-compliant)
 * 2. "Listen & Watch" button on mobile (triggers existing popup)
 */
(function() {
  'use strict';
  if (!window.location.pathname.includes('chapter-1-piano-sheet-music')) return;

  // Inject mobile-responsive CSS
  var s = document.createElement('style');
  s.textContent = [
    '@media(max-width:749px){',
      '.dk-tracker{padding:14px 16px!important;border-radius:10px!important}',
      '.dk-tracker__label{font-size:0.78rem!important;letter-spacing:0.1em!important}',
      '.dk-tracker__star{font-size:0.6rem!important}',
      '.dk-tracker__desc{font-size:0.75rem!important;margin-bottom:12px!important}',
      '.dk-tracker__bar-wrap{height:8px!important;margin-bottom:8px!important}',
      '.dk-tracker__count{font-size:0.72rem!important}',
      '.dk-tracker__sold-msg{font-size:0.75rem!important}',
      '.st-mobile-listen-btn{display:flex!important}',
      '.st-play-badge{display:none!important}',
      '.text-block.h1 h1{font-size:2rem!important;line-height:1.15!important}',
    '}',
    '.st-mobile-listen-btn{display:none;width:100%;padding:14px 20px;border:1px solid rgba(201,164,74,.35);border-radius:10px;background:rgba(201,164,74,.08);color:#c9a44a;font-size:14px;font-weight:600;cursor:pointer;align-items:center;justify-content:center;gap:10px;margin-bottom:12px;transition:all .25s;font-family:inherit}',
    '.st-mobile-listen-btn:active{background:rgba(201,164,74,.18);border-color:rgba(201,164,74,.55)}'
  ].join('\n');
  document.head.appendChild(s);

  function addListenBtn() {
    if (document.getElementById('stMobileListenBtn')) return false;
    var tracker = document.getElementById('dkTracker');
    var buyBtn = document.querySelector('[class*="buy-buttons"], form[action*="/cart/add"]');
    var anchor = tracker || buyBtn;
    if (!anchor) return false;

    var btn = document.createElement('button');
    btn.id = 'stMobileListenBtn';
    btn.className = 'st-mobile-listen-btn';
    btn.setAttribute('aria-label', 'Listen and watch options');
    btn.innerHTML = '\uD83C\uDFB5 <span>Listen & Watch</span>';
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var overlay = document.getElementById('st-img-popup-overlay');
      if (overlay) {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
    anchor.parentNode.insertBefore(btn, anchor);
    return true;
  }

  // Try immediately, then observe for late DOM
  function init() {
    if (!addListenBtn()) {
      var obs = new MutationObserver(function(m, o) {
        if (addListenBtn()) o.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { obs.disconnect(); }, 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
